import { render, staticRenderFns } from "./OverlayLinkAndContentPlain.vue?vue&type=template&id=6a0f0300&"
import script from "./OverlayLinkAndContentPlain.vue?vue&type=script&lang=js&"
export * from "./OverlayLinkAndContentPlain.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLinkAndContentPlain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports